import { PlatformAPIKeyRole } from 'shared/base';

export enum PlatformPermissions {
  ADMIN_READ = 'admin:read',
  ADMIN_WRITE = 'admin:write',
  GENERAL_READ = 'general:read',
  GENERAL_WRITE = 'general:write',
}

export const ROLE_TO_PERMISSIONS: Record<PlatformAPIKeyRole, PlatformPermissions[]> = {
  [PlatformAPIKeyRole['admin:write']]: [PlatformPermissions.ADMIN_WRITE],
  [PlatformAPIKeyRole['admin:read']]: [PlatformPermissions.ADMIN_READ],
  [PlatformAPIKeyRole['general:write']]: [PlatformPermissions.GENERAL_WRITE],
  [PlatformAPIKeyRole['general:read']]: [PlatformPermissions.GENERAL_READ],
  [PlatformAPIKeyRole['ci']]: [PlatformPermissions.GENERAL_READ],
};

export const DEPENDANT_PERMISSIONS: Record<PlatformPermissions, PlatformPermissions[]> = {
  [PlatformPermissions.ADMIN_WRITE]: [
    PlatformPermissions.ADMIN_READ,
    PlatformPermissions.GENERAL_WRITE,
  ],
  [PlatformPermissions.GENERAL_WRITE]: [PlatformPermissions.GENERAL_READ],
  [PlatformPermissions.ADMIN_READ]: [PlatformPermissions.GENERAL_READ],
  [PlatformPermissions.GENERAL_READ]: [],
};
